export function formatPhone(digits: string): string {
  if (digits.length < 4) return digits;
  if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
}

export function normalizePhoneInput(raw: string): string {
  let digits = raw.replace(/\D/g, "");
  if (digits.length === 11 && digits[0] === "1") digits = digits.slice(1);
  return formatPhone(digits.slice(0, 10));
}

export function isPhoneValid(value: string): boolean {
  const digits = value.replace(/\D/g, "");
  return /^[2-9]\d{2}[2-9]\d{6}$/.test(digits);
}

export function isEmailValid(value: string): boolean {
  return /^[^\s@,;]+@[^\s@.,;]+(\.[^\s@.,;]+)+$/.test(value.trim());
}

export const SERVICE_AREA_ZIPS = new Set([
  "21042", "21043", "21044", "21045", "21046", "21029", "21036", "21075",
  "21076", "21163", "21104", "21784", "21794", "21797", "21723", "21737",
  "21738", "20759", "20777", "20723", "20724", "20794", "21228", "21229",
  "21227", "21208", "21133", "21237", "21236", "21207", "21201", "21210",
  "21211", "21212", "21215", "21218", "21230", "21090", "21061", "21144",
  "21113",
]);
